import { FormsIcon } from 'foundations-assets/icons/components/FormsIcon';
import { EmailIcon } from 'foundations-assets/icons/components/EmailIcon';
import { MessagesIcon } from 'foundations-assets/icons/components/MessagesIcon';
import { SocialFacebookMessengerIcon } from 'foundations-assets/icons/components/SocialFacebookMessengerIcon';
import { SocialWhatsappIcon } from 'foundations-assets/icons/components/SocialWhatsappIcon';
import { TicketIcon } from 'foundations-assets/icons/components/TicketIcon';
import { SmsIcon } from 'foundations-assets/icons/components/SmsIcon';
import { CallIcon } from 'foundations-assets/icons/components/CallIcon';
import { SocialInstagramIcon } from 'foundations-assets/icons/components/SocialInstagramIcon';
export const CHANNEL_ICONS = {
  FORMS: FormsIcon,
  EMAIL: EmailIcon,
  LIVE_CHAT: MessagesIcon,
  CUSTOMER_PORTAL_THREAD_VIEW: TicketIcon,
  FB_MESSENGER: SocialFacebookMessengerIcon,
  WHATSAPP: SocialWhatsappIcon,
  SMS: SmsIcon,
  CALL: CallIcon,
  INSTAGRAM: SocialInstagramIcon
};